export default __webpack_public_path__ + "static/media/logo-y-fundo-branco.772812a0.svg";